export const fixDecimal = (number) => {
    if (typeof number !== "number" || isNaN(number)) {
        return null;
    }

    return Number(number?.toFixed(2))
}